import asanaImage from "@/assets/images/social-tools/asana.svg";
import todoistImage from "@/assets/images/social-tools/todoist.svg";
import notionImage from "@/assets/images/social-tools/notion.svg";
import trelloImage from "@/assets/images/social-tools/trello.svg";
import jiraImage from "@/assets/images/social-tools/jira.svg";
import slackImage from "@/assets/images/social-tools/slack.svg";
import clickupImage from "@/assets/images/social-tools/clickup.svg";
import confluenceImage from "@/assets/images/social-tools/confluence.svg";
import mondayImage from "@/assets/images/social-tools/monday.svg";
import linearImage from "@/assets/images/social-tools/linear.svg";

export const toolsListIconsCostCalculator = [
  {
    toolName: "Asana",
    toolIcon: asanaImage,
    toolId: "asana-tool",
  },
  {
    toolName: "Todoist",
    toolIcon: todoistImage,
    toolId: "todoist-tool",
  },
  {
    toolName: "Notion",
    toolIcon: notionImage,
    toolId: "notion-tool",
  },
  {
    toolName: "Trello",
    toolIcon: trelloImage,
    toolId: "trello-tool",
  },
  {
    toolName: "Slack",
    toolIcon: slackImage,
    toolId: "slack-tool",
  },
  {
    toolName: "Jira",
    toolIcon: jiraImage,
    toolId: "jira-tool",
  },
  {
    toolName: "ClickUp",
    toolIcon: clickupImage,
    toolId: "clickup-tool",
  },
  {
    toolName: "Confluence",
    toolIcon: confluenceImage,
    toolId: "confluence-tool",
  },
  {
    toolName: "Linear",
    toolIcon: linearImage,
    toolId: "linear-tool",
  },
  {
    toolName: "Monday",
    toolIcon: mondayImage,
    toolId: "monday-tool",
  },
];
